import { render, staticRenderFns } from "./Echart.vue?vue&type=template&id=04ca64b1"
import script from "./Echart.vue?vue&type=script&lang=js"
export * from "./Echart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports